import React from "react";
import { useState } from 'react';
import { FaFilePdf, FaFileCsv } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';
import Select from 'react-select';
import { PopUpOverlay, PopUpDivMain, ButtonExport, ButtonDiv } from "./styles";
import { FilterButton } from "../styles";
import { useEntrys } from '../../../hooks/useEntrys';

export default function (props) {
  const [exportType, setExportType] = useState('');
  const [placeholder, setPlaceholder] = useState('Selecione o tipo de exportação');
  const [loading, setLoading] = useState(false);

  const { exportEntries } = useEntrys();

  async function Export() {
    if (!exportType) {
      alert('Selecione o tipo de exportação');
      return;
    }

    setLoading(true);
    const format = exportType === 'PDF' ? 'pdf' : 'csv';
    const { initialDate, finalDate, type } = props.filterOptions || {};

    await exportEntries(format, initialDate, finalDate, type);
    setLoading(false);
  }

  function handleFilterOptions(e) {
    setExportType(e.value);
    setPlaceholder(e.label);
  }

  function closePopup() {
    props.setLoader(false);
    props.setShowPopup(false);
  }

  const options = [
    { value: 'PDF', label: <><FaFilePdf style={{ marginRight: 8 }} /> Exportar PDF</> },
    { value: 'CSV', label: <><FaFileCsv style={{ marginRight: 8 }} /> Exportar CSV</> },
  ];


  return (
    <PopUpOverlay onClick={(e) => { if (e.target === e.currentTarget) closePopup(); }}>
      <PopUpDivMain>
        <h4>Exportar Extrato</h4>
        <Select
          className="select"
          onChange={(e) => handleFilterOptions(e)}
          options={options}
          placeholder={placeholder}
          menuPlacement="auto"
          styles={{
            control: (base) => ({
              ...base,
              color: 'var(--text-primary)',
              backgroundColor: 'var(--bg-color, #fff)',
              borderColor: '#555',
              borderRadius: 8,
              minHeight: 50,
              fontSize: '0.9rem',
            }),
            singleValue: (base) => ({
              ...base,
              color: 'var(--text-primary)',
            }),
            option: (base, state) => ({
              ...base,
              color: '#333',
              backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
              cursor: 'pointer',
              fontSize: '0.9rem',
            }),
            placeholder: (base) => ({
              ...base,
              color: '#999',
              fontSize: '0.9rem',
              whiteSpace: 'nowrap',
              overflow: 'visible',
            }),
            menu: (base) => ({
              ...base,
              borderRadius: 8,
              overflow: 'hidden',
              zIndex: 10,
            }),
          }}
        />
        <ButtonDiv>
          <button className="btn btn-secondary" onClick={() => closePopup()}>Fechar</button>
          {!loading
            ? <ButtonExport className="btn" onClick={() => Export()}>Exportar</ButtonExport>
            : <FilterButton disabled>Exportando...</FilterButton>
          }
        </ButtonDiv>
      </PopUpDivMain>
    </PopUpOverlay>
  );
}
